import axios from 'axios';
import Loading from '../Components/Loading';
import Cookies from 'js-cookie';
import { createContext, useEffect, useState } from 'react';


export const Authorization = createContext()

const AuthContextProvider = ({ children }) => {
    const [tokens, setTokens] = useState(() => Cookies.get('token') ? JSON.parse(Cookies.get('token')) : null)
    const [user, setUser] = useState({})
    const [reload, setReload] = useState()
    const [loading, setLoading] = useState(true)

    const getTokens = (data) => {
        Cookies.set('token', JSON.stringify(data), { expires: 366 })
        setTokens(data)
    }
    const getUser = (data) => {
        Cookies.set('user', JSON.stringify(data), { expires: 366 })
        setUser(data)
    }
    const getUserInformation = async (token) => {
        const data = await axios.get('/user/show',
            { headers: { Authorization: `${token.token_type} ${token.access_token}` } })
            .then(({ data }) => {
                setUser(data.data)
                return data.data
            })
            .catch(err => {
                alert(err.response?.data.message || 'اطلاعات کاربر پیدا نشد')
                setUser(() => Cookies.get('user') ? JSON.parse(Cookies.get('user')) : {})
            })
            .finally(() => setLoading(false))
        return data
    }
    useEffect(() => {
        if (tokens) getUserInformation(tokens)
        else setLoading(false)
    }, [tokens, reload])


    const contextData = {
        tokens,
        user,
        getTokens,
        getUser,
        setTokens,
        setUser,
        getUserInformation,
        setReload
    }

    return (
        <>
            <Authorization.Provider value={contextData}>
                {loading ? <Loading /> : children}
            </Authorization.Provider>
        </>
    );
};

export default AuthContextProvider;